import axios from "axios";

export const getInvitations = async (personId) => {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/invitations?person_id=${personId}`);
    return response.data;
}